(() => {
  const builders = document.querySelectorAll('[data-project-builder]');

  builders.forEach((builder) => {
    const form = builder.querySelector('form');
    const output = builder.querySelector('[data-builder-output]');
    const summary = builder.querySelector('[data-builder-summary]');

    if (!form || !output || !summary) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const rows = [];

      data.forEach((value, key) => {
        if (!value) return;
        rows.push(`<li><strong>${key}:</strong> ${String(value).replace(/[<>&]/g, '')}</li>`);
      });

      summary.innerHTML = rows.length ? `<ul class="hire-list">${rows.join('')}</ul>` : '<p>Please add a few project details first.</p>';
      output.hidden = false;
      output.focus();
    });
  });
})();
